import React from "react";
import HorizontalScroller from "ui/atoms/HorizontalScroller";
import UpNextCard from "./UpNext/UpNextCard";
import classNames from "classnames";
import useUpNextState from "./UpNext/useUpNextState";
import TabContainer from "ui/atoms/Container/TabContainer";
import { useMountEffect } from "@react-hookz/web";
import useAuth from "util/useAuth/useAuth";
import SetlistSignupBanner from "./SetlistSignupBanner";
import useScrollElementIntoHorizontalView from "./useScrollElementIntoHorizontalView";

interface SetlistProps {
  locked: boolean;
}

export default function Setlist({ locked }: SetlistProps) {
  const upNextState = useUpNextState();
  const auth = useAuth();
  const scrollElement = useScrollElementIntoHorizontalView(
    upNextState.nextToDoElementId
  );

  return (
    <TabContainer
      title={"Your Setlist"}
      subtitle="Ear training games from easy to hard"
      locked={locked}
    >
      <HorizontalScroller
        ref={scrollElement}
        innerContainerPaddingClassName={""}
        itemWidthClassName=""
        itemMarginRightClassName={"mr-2 md:mr-4"}
        count={upNextState.upNext.length}
        render={(index) => {
          const difficulty = upNextState.upNext[index].difficulty;
          const games = upNextState.upNext[index].games;
          const nextUpIsInThisDifficulty =
            upNextState.nextTodo &&
            upNextState.nextTodo.difficulty === difficulty;

          return (
            <div key={index}>
              <div className={"mb-2 flex"}>
                <div className={"left-0 sticky flex items-center z-10"}>
                  <div
                    className={
                      "rounded inline-block py-1 px-2 font-brik mr-2 border border-slate-300"
                    }
                  >
                    {difficulty} Mode
                  </div>

                  {nextUpIsInThisDifficulty && (
                    <div className={"text-white"}>You are here</div>
                  )}
                </div>
              </div>

              <div
                className={classNames(
                  "flex border-2 border-white rounded p-2 md:p-4",
                  auth.type === "loggedout" && "mb-2"
                )}
              >
                {games.map((game, i) => {
                  const isLast = i === games.length - 1;
                  const isUpNext = upNextState.nextTodo
                    ? upNextState.nextTodo.game === game.game &&
                      upNextState.nextTodo.difficulty === difficulty
                    : false;

                  return (
                    <div
                      key={game.game}
                      className={classNames(
                        "inline-block",
                        !isLast && "mr-2 md:mr-4"
                      )}
                      id={game.elementId}
                    >
                      <UpNextCard
                        difficulty={game.difficulty}
                        countComplete={game.completionStatus.countComplete}
                        total={game.completionStatus.total}
                        selected={isUpNext}
                        game={game.game}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          );
        }}
      />

      {auth.type === "loggedout" && <SetlistSignupBanner type="lives" />}
    </TabContainer>
  );
}
